import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
Vue.axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
Vue.axios.defaults.headers.common['Accept'] = 'application/json';
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
import OrganiserWizard from '../src/components/organisers/OrganiserWizard.vue';

const csrfTag = document.querySelector('meta[name="csrf-token"]');
if (csrfTag) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfTag.getAttribute('content');
}
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

Vue.config.productionTip = false;

const mountOrganiserOnboarding = () => {
  const node = document.getElementById('organiser-onboarding');
  if (!node) return;

  let props = {};
  try {
    props = JSON.parse(node.dataset.props || '{}');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to parse wizard props', error);
  }

  new Vue({
    render: (h) => h(OrganiserWizard, { props })
  }).$mount(node);
};

document.addEventListener('DOMContentLoaded', () => {
  // The layout also mounts a Vue app on #app. Mount this nested app after it,
  // otherwise the parent app recompiles the form and drops submit handlers.
  window.setTimeout(mountOrganiserOnboarding, 0);
});
